const ContactSection = () => {
    return (
        <section className="sec sec-contact" id="contact">
            <div className="contact__content">
                <div className="contact__content-wrap">
                    <h2 className="contact__title">Contact</h2>
                    <div className="contact__address">
                        <div className="contact__address-title">Address</div>
                        <div className="contact__address-text">
                            {`9 RAFFLES PLACE #26-01 `}
                            <br />
                            REPUBLIC PLAZA SINGAPORE 048619
                        </div>
                    </div>
                    <div className="contact__div"></div>
                    <div className="contact__email">
                        <div className="contact__email-title">Email</div>
                        <div className="contact__email-link">
                            <a href="mailto:ncv_contact@ncvgames.com">ncv_contact@ncvgames.com</a>
                        </div>
                    </div>
                </div>
                <div className="contact__deco">NCV GAMES</div>
            </div>
        </section>
    );
};

export default ContactSection;
